import { defineMiddleware } from '../middleware'
import { useAuthStore } from '@/features/auth'
import { queryClient } from '@/shared/api'
import { fetchMe, SESSION_QUERY_KEY } from '@/entities/session'

defineMiddleware('auth', async (to) => {
  const authStore = useAuthStore()

  if (!authStore.isAuthenticated) {
    const query = to.fullPath === '/' ? undefined : { redirect: to.fullPath }

    return { path: '/auth/login', query }
  }

  try {
    const response = await queryClient.ensureQueryData({
      queryKey: SESSION_QUERY_KEY,
      queryFn: fetchMe,
    })

    authStore.setUser(response.data)
  } catch {
    authStore.clearAuth()
    return { path: '/auth/login', query: { redirect: to.fullPath } }
  }

  return true
})
